import {ListNode, type ListType, type SerializedListNode,} from "@lexical/list";
import type {DOMExportOutput, EditorConfig, LexicalNode, NodeKey,} from "lexical";

export class DashListNode extends ListNode {
    static getType(): string {
        return "dash-list";
    }

    static clone(node: DashListNode): DashListNode {
        return new DashListNode(node.__listType, node.__start, node.__key);
    }

    constructor(listType: ListType = "bullet", start = 1, key?: NodeKey) {
        super(listType, start, key);
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = super.createDOM(config);
        element.classList.add("rich-text-dash");
        return element;
    }

    updateDOM(prevNode: DashListNode, dom: HTMLElement): boolean {
        if (!dom.classList.contains("rich-text-dash")) {
            dom.classList.add("rich-text-dash");
        }
        return false;
    }

    exportDOM(): DOMExportOutput {
        const element = document.createElement("ul");
        element.classList.add("rich-text-ul", "rich-text-dash");
        return { element };
    }

    static importJSON(serializedNode: SerializedListNode): DashListNode {
        const node = new DashListNode(serializedNode.listType || "bullet");
        node.setFormat(serializedNode.format);
        node.setIndent(serializedNode.indent);
        node.setDirection(serializedNode.direction);
        return node;
    }


    exportJSON(): SerializedListNode {
        return {
            ...super.exportJSON(),
            type: "dash-list",
            version: 1,
        };
    }

    static importDOM(): Record<string, any> {
        return {
            ul: (domNode: HTMLElement) => {
                if (domNode.classList?.contains("rich-text-dash")) {
                    return {conversion: () => ({node: new DashListNode()}), priority: 1};
                }
                return null;
            },
        };
    }
}

export function $createDashListNode(): DashListNode {
    return new DashListNode();
}

export function $isDashListNode(node?: LexicalNode | null): node is DashListNode {
    return node instanceof DashListNode;
}
